<template>
  <div>
    <BaseCard
      title="datos de la factura de proveedor"
      :footer-visible="false"
      :loading="loading"
      @save-button-click="handleSaveButtonClick"
    >
      <PurchaseInvoiceProfileForm
        ref="purchase-invoice-profile-form"
        v-model="purchaseInvoice"
      />
      <hr class="m-0 mx-2">
      <PurchaseInvoiceBillingForm
        ref="purchase-invoice-billing-form"
        v-model="purchaseInvoice"
      />
    </BaseCard>
    <b-row
      align-v="center"
      align-h="end"
    >
      <b-col cols="auto">
        <b-button
          variant="primary"
          class="text-nowrap rounded-sm px-2"
          :disabled="loading"
          @click="handleSaveButtonClick"
        >
          Guardar factura
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PurchaseInvoicesApi from '@/api/purchase-invoices-api'
import BaseCard from '@/components/ui/card/BaseCard.vue'
import PurchaseInvoiceProfileForm from '@/components/purchase-invoices/form/PurchaseInvoiceProfileForm.vue'
import PurchaseInvoiceBillingForm from '@/components/purchase-invoices/form/PurchaseInvoiceBillingForm.vue'

export default {
  name: 'Create',
  components: { PurchaseInvoiceBillingForm, PurchaseInvoiceProfileForm, BaseCard },
  data() {
    return {
      loading: false,
      purchaseInvoice: {},
    }
  },
  methods: {
    async handleSaveButtonClick() {
      const valid = await this.$refs['purchase-invoice-profile-form'].validateForm()
      if (!valid) {
        return
      }

      this.loading = true
      try {
        const { documentation } = this.$refs['purchase-invoice-profile-form'].getDocumentationData()
        const response = await PurchaseInvoicesApi.create({ ...this.purchaseInvoice, documentation })
        const { id } = response.data
        await this.$router.replace({ name: 'viewPurchaseInvoice', params: { id }, query: { origin: this.$route.query.origin } })
      } catch (error) {
        this.$toast.error(error.response?.data?.error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
</style>
